var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2512 3.32105C13.9104 -1.01978 6.86436 -1.01978 2.52353 3.32105L0.168457 5.67612L2.52353 8.0312C6.86436 12.372 13.9104 12.372 18.2512 8.0312L20.6063 5.67612L18.2512 3.32105ZM10.3898 9.77233C8.12583 9.77233 6.29357 7.94007 6.29357 5.67612C6.29357 3.41218 8.12583 1.57992 10.3898 1.57992C12.6537 1.57992 14.486 3.41218 14.486 5.67612C14.486 7.94007 12.6537 9.77233 10.3898 9.77233Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3897 8.20865C11.7884 8.20865 12.9223 7.07479 12.9223 5.6761C12.9223 4.27741 11.7884 3.14355 10.3897 3.14355C8.99104 3.14355 7.85718 4.27741 7.85718 5.6761C7.85718 7.07479 8.99104 8.20865 10.3897 8.20865Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/OpenEye.5dcaa09176550e9501cf4a603996e161.svg";
export { ForwardRef as ReactComponent };